// utils/abortController.js
let controller = new AbortController();

export const getAbortController = () => {
  if (controller.signal.aborted) controller = new AbortController();
  return controller;
};

export const abortAll = () => {
  controller.abort();
};
